/* eslint-disable class-methods-use-this */
import { getUniqueId } from 'utils/uniqueId';

import { CellItem } from './types';

/*
    Class that provides the data for GridView.
*/

export default class DataProvider {
    private _data: CellItem[][] = [];

    constructor(data: CellItem[][]) {
        this._data = data;
    }

    public getStableId = (row: number, index: number) => {
        return this._data[row][index].id;
    };

    public getItem = (row: number, index: number) => {
        return this._data[row][index];
    };

    public getAllData = () => {
        return this._data;
    };

    public getSize = () => {
        return this._data.length;
    };
}
